module.exports = __webpack_public_path__ + "media/Icons/camera-pos/cam_9-2d149659ca01f1a2947ff0a3ced0f2dc.png";